module.exports = __webpack_public_path__ + "static/media/notify.fcbc3498.svg";